<template>
	<div>
		<template v-if="Object.keys(selectedStudent).length > 0 && roleRules.REPORTS_FLG === 'Y'">
			<section>
				<div class="table-responsive">
					<table-editable-list :columns="columns"
																:show-select="false"
																:show-actions="false">
						<template slot="data-row">
							<template v-for="(year, yearIdx) in files">
								<tr :key="`year_${yearIdx}`" v-if="year.SCHOOL_YEAR_DESC.length > 0">
									<td colspan="3">
										<strong>
											{{ year.SCHOOL_YEAR_DESC }}
										</strong>
									</td>
								</tr>
								<template v-for="(letter, letterIdx) in year.FILES">
									<table-list-row :key="`letter_${yearIdx}_${letterIdx}`"
																	:columns="columns"
																	:rowdata="letter"
																	:rowIndex="letterIdx"
																	:showActions="false"
																	:useAnchor="true">
										<template slot="name">
											<a :href="letter.REPORT_URL" target="_blank" tabindex="0" style="cursor: pointer;">
												<font-awesome-icon :icon="getIcon(letter)" style="color: #333333"></font-awesome-icon>
												{{ letter.REPORT_TITLE }}
											</a>
										</template>
									</table-list-row>
								</template>
							</template>
						</template>
					</table-editable-list>
				</div>
			</section>
		</template>
		<template v-else>
			{{ $t('MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod') }}
		</template>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import FileCabinet from '../../api/FileCabinet';

	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		data() {
			return {
				columns: [
					{
						heading: this.$t( 'MAIN_CONTENT.ReportFiles.name' ),
						key: 'REPORT_TITLE',
						customCol: 'name'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.ReportFiles.school' ),
						key: 'SCHOOL_TITLE',
						customCol: 'school'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.ReportFiles.datePosted' ),
						key: 'DISPLAY_DATE',
						customCol: 'postedDate'
					},
				],
				files: []
			}
		},
		computed: {
			...mapGetters(['role', 'roleRules', 'selectedStudent'])
		},
		components: {
			TableEditableList,
			TableListRow
		},
		methods: {
			loadFiles() {
				const self = this;

				// REPORT_TYPE_CODE:	'TRANSCRIPT'
				let query = {
					student_rid: this.selectedStudent.STUDENT_RID
				};

				switch (this.$route.path) {
					case '/transcript':
						query.REPORT_TYPE_CODE = 'TRANSCRIPT';
						break;
					case '/letters':
						query.REPORT_CATEGORY_CODE = 'NOTICE';
						break;
					case '/report-cards':
						query.REPORT_TYPE_CODE = 'REPORTCARD';
						break;
					case '/progress-reports':
						query.REPORT_TYPE_CODE = 'PROGRESS';
						break;
					default:
						break;
				}

				const fileCabinet = new FileCabinet({
					route: '/reports',
					query: query
				});

				const promise = fileCabinet.get();

				promise.then(response => {
					self.$set(self, 'files', self.formatData(response.data.data));
				})
				.catch(error => {
					console.log(error);
				});
			},
			formatData(unformattedData) {
				let years = [];

				for(let y in unformattedData) {
					let data = unformattedData[y];
					let hasYear = false;

					// add automatically if years is an empty array
					if(years.length > 0) {
						// Loop through the years array and see if the year exists
						for(let x in years) {
							let year = years[x];

							if(data.SCHOOL_YEAR_DESC === year.SCHOOL_YEAR_DESC) {
								hasYear = true;
							}
						}
					}

					if(!hasYear) {
						years.push({
							SCHOOL_YEAR_DESC: data.SCHOOL_YEAR_DESC,
							FILES: this.getFiles(data.SCHOOL_YEAR_DESC, unformattedData)
						});
					}
				}

				return years;
			},
			getFiles(schoolYear, files) {
				let formattedFiles = [];

				for(let l in files) {
					let letter = files[l];

					if(letter.SCHOOL_YEAR_DESC === schoolYear) {
						letter.DISPLAY_DATE = this.$options.filters.date(letter.CREATED_DATE);
						formattedFiles.push(letter);
					}
				}

				return formattedFiles;
			},
			getIcon(file) {
				let icon = '';

				switch(file.REPORT_TYPE_CODE) {
					case 'ATTEND':
						icon = 'calendar-check';
						break;
					case 'DISC':
						icon = 'gavel';
						break;
					default:
						icon = 'file-alt';
						break;
				}

				if(file.REPORT_TYPE_CODE !== 'ATTEND' && file.REPORT_TYPE_CODE !== 'DISC') {
					let extensionType =
						file.CONTENT_FILENAME.substring(file.CONTENT_FILENAME.length - 4, file.CONTENT_FILENAME.length);

					switch(file.CONTENT_FILETYPE) {
						case 'pdf':
							icon = { prefix: 'far', iconName: 'file-pdf'};
							break;
						case 'xls':
							icon = 'file-excel';
							break;
						case 'other':
							if(file.CONTENT_FILETYPE === 'other' && extensionType === 'pptx') {
								icon = 'file-powerpoint';
							}
							break;
						default:
							break;
					}
				}

				return icon;
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'archive');

			switch (this.$route.path) {
				case '/transcript':
					this.$store.commit('setTitle', 'MAIN_CONTENT.ReportFiles.navPanelTranscript');
					break;
				case '/letters':
					this.$store.commit('setTitle', 'MAIN_CONTENT.ReportFiles.navPanelLetters');
					break;
				case '/report-cards':
					this.$store.commit('setTitle', 'MAIN_CONTENT.ReportFiles.navPanelReportCards');
					break;
				case '/progress-reports':
					this.$store.commit('setTitle', 'MAIN_CONTENT.ReportFiles.navPanelProgressReports');
					break;
				default:
					break;
			}

			this.$store.commit('setUseHeader', true);

			if(this.roleRules.REPORTS_FLG === 'Y') {
				if(Object.keys(this.selectedStudent).length > 0) {
					this.loadFiles();
				}
			} else {
				this.$router.push({name: 'HomePage'});
			}
		}
	}
</script>
